import { useGetOrderSummaryQuery } from 'src/graphql/generated';

export const useGetOrderSummary = (
  orderId?: string,
  advertiserNation?: string | null,
) => {
  const { data: { orderSummary } = {} } = useGetOrderSummaryQuery({
    variables: {
      orderId: orderId!,
      advertiserNation: advertiserNation!,
    },
    fetchPolicy: 'cache-first',
    skip: !orderId || !advertiserNation,
  });

  return orderSummary;
};
